import FileDrop from "@/components/ui/file-drop";

import KnowledgeSourceButtons from "../knowledge-source-buttons/knowledge-source-buttons";

const XMLSource = () => {
    return (
        <div>
            <FileDrop fileType="XML" />
            <div className="mt-4 border-t p-4">
                <KnowledgeSourceButtons />
            </div>
        </div>
    );
};

export default XMLSource;
